<script setup>

import {onMounted, ref} from "vue";
import ChevronDown from "@/components/icons/ChevronDown.vue";

const props = defineProps({
  modelValue: {
    type: [String, Number],
    required: true,
  },
  items: {
    type: Array,
    required: true,
    default: () => [],
  },
  width: {
    type: String,
    default: () => "64px"
  },
  height: {
    type: [String, null],
    default: null
  },
  disabled: {
    type: Boolean,
    default: false
  },
  listJustify: {
    type: String,
    default: "center"
  }
});

const emit = defineEmits(["update:modelValue"]);

const isShowDropdown = ref(false);

onMounted(() => {
  if (dropdownRef.value) {
    if (props.width) dropdownRef.value.style.width = props.width;
    if (props.height) dropdownRef.value.style.height = props.height;
  }
});

const dropdownRef = ref(null);

const setValue = (value) => {
  emit("update:modelValue", value);
  isShowDropdown.value = false;
};

const toggleDropdown = () => {
  if (!props.disabled) {
    isShowDropdown.value = !isShowDropdown.value;
  }
};

</script>

<template>
  <div
    ref="dropdownRef"
    v-click-outside="() => isShowDropdown = false"
    class="dropdown"
    :class="{'dropdown--show': isShowDropdown, 'dropdown--disabled': props.disabled}"
  >
    <div
      class="dropdown__selected"
      @click="toggleDropdown"
    >
      {{ modelValue ? modelValue : 'Выберите пункт' }}
      <ChevronDown />
    </div>
    <div
      v-if="isShowDropdown"
      class="dropdown__list-wrapper"
    >
      <div class="dropdown__list scroll-thin">
        <div
          v-for="item in items"
          :key="item"
          class="dropdown__item"
          :style="{ justifyContent: props.listJustify }"
          :class="{'dropdown__item--selected': item === modelValue}"
          @click="setValue(item)"
        >
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.dropdown {
  align-items: center;
  border: 1px solid #DEDEDE;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 8px 12px;
  position: relative;
  user-select: none;
  height: 36px;
  color: #373D3F;

  &--disabled {
    cursor: not-allowed;
    color: #DEDEDE;
  }

  &--show {
    background: #F7F8FD;
    border: 1px solid #DEDEDE;
  }

  &__list-wrapper {
    padding: 14px 7px 14px 14px;
    z-index: 100;
    left: 0;
    position: absolute;
    top: 45px;
    background: #FFFFFF;
    border-radius: 8px;
    box-shadow: 1px 2px 10px 0 #131E2726;
    width: 100%;
  }

  &__list {
    padding-right: 7px;
    max-height: 218px;
    display: flex;
    flex-direction: column;
  }

  &__item {
    justify-content: center;
    align-items: center;
    display: flex;
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 400;

    &:hover {
      background: #EEF1F4;
    }

    &--selected {
      color: #1F9AFF;

      &:hover {
        background: #E0F0FF;
      }
    }
  }

  &__selected {
    align-items: center;
    display: flex;
    font-size: 14px;
    font-weight: 400;
    gap: 4px;
    justify-content: space-between;
    width: 100%;

    svg {
      color: #CACACA;
    }
  }
}
</style>